module.exports = __webpack_public_path__ + "static/media/Mobile9M.425a7c35.webp";